module.exports = __webpack_public_path__ + "media/logos/press-logo-businesses-white-0f3bdaa4.png";